import { useEffect, useState, useContext, useRef } from "react";
import { Dimmer, Loader, Input } from "semantic-ui-react";
import styles from "./Collection.module.scss";
import { GlobalContext } from "@/store";
import { useRouter } from "next/router";
import useWeb3 from "@/hooks/useWeb3";
import VerifiedIcon from "../ui/VerifiedIcon.component";

const limit = 40;
const Collections = () => {
  // define local variables

  const listInnerRef = useRef();

  const [state, dispatch] = useContext(GlobalContext);

  const [offset, setOffset] = useState(0);

  const [loadingBackend, setLoadingBackend] = useState(true);

  const [collectionList, setCollectionList] = useState([]);

  const [searchCriteria, setSearchCriteria] = useState("");

  const [hasReachBottom, setHasReachBottom] = useState(false);

  const { DGMarketplace } = useWeb3();

  const router = useRouter();

  useEffect(() => {
    fetchCollections("");
  }, []);

  useEffect(() => {
    if (state.marketplaceShouldRefresh) {
      fetchCollections(searchCriteria);
    }
  }, [state.marketplaceShouldRefresh]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      //fetchGroups(true);
      fetchCollections(searchCriteria, true);
    }, 500);

    return () => clearTimeout(timeout);
  }, [searchCriteria]);

  useEffect(() => {
    if (offset > 0) {
      fetchCollections(searchCriteria);
    }
  }, [offset]);

  const onScroll = () => {
    if (listInnerRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;

      const scroll = scrollHeight - scrollTop;
      const diff = scroll - clientHeight;

      if (Math.abs(diff) <= 1) {
        if (offset >= 0 && !hasReachBottom) {
          setOffset((state) => state + limit);
        }
      }
    }
  };

  const handleCollectionClick = (collection) => {
    router.push(
      `/marketplace/collection/${encodeURIComponent(collection.name)}/${
        collection.address
      }`
    );
  };

  const fetchCollections = async (searchCriteria, replace = false) => {
    const collections = await DGMarketplace.getCollections(
      "",
      searchCriteria,
      limit,
      replace ? 0 : offset
    );

    if (replace) {
      setCollectionList(collections);
    } else {
      const tempItems = [...collectionList];
      setCollectionList([...tempItems, ...collections]);
    }

    console.log("hasReachBottom", hasReachBottom);
    setHasReachBottom(collections.length < limit);

    setLoadingBackend(false);

    dispatch({
      type: "set_marketplaceRefresh",
      data: false,
    });
  };

  return (
    <div className={styles.main_container}>
      <div className={styles.page_container}>
        <h4>Collections</h4>
        <div style={{ flex: 6, marginTop: "10px" }}>
          <Input
            type="text"
            className={styles.searchBar}
            placeholder="Type here to start searching..."
            onChange={(e) => setSearchCriteria(e.target.value)}
          />
        </div>
        <div className={styles.row}>
          <div className={styles.rowItems}>
            <div>
              {loadingBackend ? (
                <Dimmer active>
                  <Loader>Loading</Loader>
                </Dimmer>
              ) : (
                <div
                  className={styles.row}
                  ref={listInnerRef}
                  onScroll={onScroll}
                >
                  {collectionList.map((collection, index) => (
                    <div
                      className={styles.container}
                      key={index}
                      onClick={handleCollectionClick.bind(null, collection)}
                    >
                      <div className={styles.imageContainer}>
                        <img
                          src={collection.images[0]}
                          className={styles.image}
                        />
                      </div>
                      <div className={styles.name}>
                        <span style={{ textOverflow: "ellipsis" }}>
                          {collection.name}
                        </span>
                        {collection.isVerifiedCreator ? <VerifiedIcon /> : null}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Collections;
